import type { RenderRule } from "src/types/utility";

type ConditionalRenderProps<T> = {
  currentValue: T;
  rules: RenderRule<T>[];
  defaultComponent: React.ReactElement | null;
};

function isPredicate<T>(
  condition: RenderRule<T>["condition"]
): condition is (value: T) => boolean {
  return typeof condition === "function";
}

export function conditionalRender<T>({
  rules,
  currentValue,
  defaultComponent,
}: ConditionalRenderProps<T>) {
  const match = rules.find((rule) => {
    if (isPredicate(rule.condition)) {
      return rule.condition(currentValue);
    }

    return rule.condition === currentValue;
  });

  return match ? match.component : defaultComponent;
}
